import { Asset } from '../v2/components/Asset'
import { Asset as AssetType } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

interface Props {
  image: AssetType
}

export default function PartnerItem({ image }: Props): ReactElement {
  return (
    <span className="w-full min-h-[140px] flex justify-center items-center overflow-visible">
      <Asset resource={image as AssetType} className="object-contain" width={220} height={100} />
    </span>
  )
}
